import 'reflect-metadata';
import pbkdf2 from 'pbkdf2';
import { singleton } from 'tsyringe';
import * as Buffer from 'buffer';

@singleton()
export class CryptoService {
    pbkdf2(message: string, key: string, iterations: number): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            console.log('pbkdf2 str:' + Date.now());
            pbkdf2.pbkdf2(message, key, iterations, 64, 'sha256', (err: Error, derivedKey: Buffer) => {
                console.log('pbkdf2 end:' + Date.now());
                if (err) reject(err);
                resolve(derivedKey.toString('hex'));
            });
        });
    }
}
